module.exports = __webpack_public_path__ + "img/2020.f6e0b377.png";